import { render, staticRenderFns } from "./WorkflowEditDetails.vue?vue&type=template&id=10699316&scoped=true"
import script from "./WorkflowEditDetails.vue?vue&type=script&lang=js"
export * from "./WorkflowEditDetails.vue?vue&type=script&lang=js"
import style0 from "./WorkflowEditDetails.vue?vue&type=style&index=0&id=10699316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10699316",
  null
  
)

export default component.exports